import { render, staticRenderFns } from "./unearnedbalance.vue?vue&type=template&id=483883da&scoped=true"
import script from "./unearnedbalance.vue?vue&type=script&lang=js"
export * from "./unearnedbalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483883da",
  null
  
)

export default component.exports